<template>
  <ul class="nav navbar-nav bookmark-icons">
    <li class="nav-item dropdown dropdown-project">
      <el-dropdown
          ref="body"
          popper-class="portal"
          placement="bottom-start">
        <a class="d-flex align-items-center nav-link">
          <icon-sax class="ft-20 text-dark"
                    type="transfer" />
          <span v-safe-html="$t(getCurrent.subject)"
                class="m-l-10 selected-project cgBase" />
        </a>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="i in getOthers"
                              :key="i.portal">
              <router-link
                  :to="{
                    name: i.route,
                    params: { id: route.params.id }
                  }"
                  class="d-flex justify-content-start align-items-center">
                <div class="jd">
                  <icon-sax :hover="false"
                            class="ft-24 cgCCC"
                            type="circle" />
                </div>
                <span v-safe-html="$t(i.subject)"
                      class="m-l-5 m-r-8" />
              </router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </li>
  </ul>
</template>

<script setup>

/**
 * 系統切換器
 *
 * ## 顯示規則 (2026-09 從二元 toggle 改成清單時變更)
 *
 * 只有兩個系統的時候, 按鈕顯示的是「**要切過去的那一個**」——
 * 在我的教會顯示「牧養系統」, 反之亦然。三個系統之後這個語意不成立了
 * (「另一個」有兩個), 所以改成:
 *
 *   按鈕 = 目前所在系統, 下拉 = 其他可切換的系統
 *
 * 這會讓既有兩個 portal 的按鈕文字反轉, 是刻意的。
 *
 * ## 清單來源
 *
 * `EnumPortalList` (enum/portal), 由 `usePortal` 依權限過濾 ——
 * 榮耀堂首頁只有 org=4 拿得到權限群組 61, 其他教會這裡就只會有兩項。
 */

import IconSax from "@/component/IconSax.vue"

import {computed, ref, watch} from "vue"
import {useRoute} from "vue-router"
import {usePortal} from "@/hook/usePortal";

const body = ref()

const route = useRoute()

const {
  getPortalList
} = usePortal()

//目前所在的系統 (路由 meta 對不上時退回清單第一項, 不讓 $t(undefined) 炸掉)
const getCurrent = computed(() =>
    getPortalList.value.find(i => i.portal === route.meta.portal) ?? getPortalList.value[0]
)

//可以切過去的其他系統
const getOthers = computed(() =>
    getPortalList.value.filter(i => i.portal !== getCurrent.value?.portal)
)

watch(()=>route.name, ()=> body.value.handleClose(), {deep: true})

</script>

<style scoped lang="scss">
// 「我的教會 / 牧養系統 / 榮耀堂首頁」固定單行、不折行
.selected-project {
  white-space: nowrap;

}
</style>
